import React, { useEffect, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { InvoiceProcessed } from '../../../components/InvoiceProcessed'
import PaymentInfo from '../../../components/PaymentInfo'
import Wrapper from '../../../../../Contractor/Wrapper'
import { TopBarMobileIdle } from '../../../../InvoiceDetails/components/ScreenWrapper'
import { useResponsive } from '@linqpal/components/src/hooks'
import CreatePassword from '../../../components/CreatePassword'
import InfoAlert from '../../../components/InfoAlert'

const InvoiceReceiptMobile = ({
  invoice,
  paymentMethodData: initialPaymentMethodData,
  onCreateAccount,
}) => {
  const [paymentMethodData, setPaymentMethodData] = useState(() => {
    if (initialPaymentMethodData) {
      return initialPaymentMethodData
    }
    const storedPaymentMethodData = localStorage.getItem('paymentMethodData')
    return storedPaymentMethodData ? JSON.parse(storedPaymentMethodData) : null
  })

  useEffect(() => {
    if (initialPaymentMethodData) {
      setPaymentMethodData(initialPaymentMethodData)
    }
  }, [initialPaymentMethodData])

  const { mobileWidth } = useResponsive()
  return (
    <Wrapper
      containerStyle={{
        alignSelf: 'center',
      }}
      toolbar={<TopBarMobileIdle />}
      contentContainerStyle={{ height: '100%' }}
      styleWidth={'100%'}
    >
      <View
        style={[
          styles.container,
          { width: mobileWidth > 576 ? '100%' : mobileWidth - 40 },
        ]}
      >
        <View style={styles.infoAlert}>
          <InfoAlert />
        </View>
        <CreatePassword
          onPress={onCreateAccount}
          containerStyle={styles.passwordContainer}
        />

        <InvoiceProcessed
          titleStyle={styles.invoiceProcessedTitle}
          infoStyle={styles.invoiceProcessedInfo}
          containerStyle={{ maxWidth: mobileWidth, width: mobileWidth }}
        />
        <PaymentInfo invoice={invoice} paymentMethodData={paymentMethodData} />
      </View>
    </Wrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    maxWidth: '100%',
    width: 350,
  },
  passwordContainer: {
    paddingHorizontal: 0,
    marginBottom: 20,
  },
  passwordTitle: {
    fontSize: 16,
    lineHeight: 24,
    alignSelf: 'flex-start',
    textAlign: 'left',
    width: '100%',
  },
  passwordInfo: {
    fontSize: 14,
    lineHeight: 20,
    alignSelf: 'flex-start',
    textAlign: 'left',
    width: '100%',
  },
  invoiceProcessedTitle: {
    fontSize: 20,
    lineHeight: 32,
    width: '100%',
  },
  invoiceProcessedInfo: {
    fontSize: 14,
    lineHeight: 28,
    width: '100%',
  },
  infoAlert: {
    marginBottom: 10,
    marginRight: -4,
  },
  poweredByContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: 10,
    marginBottom: 18,
    marginRight: 18,
  },
})

export default InvoiceReceiptMobile
